
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    
import React from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import CreateListing from "../../src/containers/CreateListing";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import AuthenticatedContainer from "../../src/containers/WithAuth";

function CreateListingPage() {
  function handleClick(event) {
    event.preventDefault();
  }

  return (
    <Container disableGutters={true} maxWidth="lg">
      <CreateListing />
    </Container>
  );
}

const __Page_Next_Translate__ = AuthenticatedContainer(CreateListingPage, {});


    export default __appWithI18n(__Page_Next_Translate__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
    });
  